//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AnalyMode",1,0],[0,"BlankBody",1,0],[0,"CheckType",1,0],[0,"ClrSetName",1,0],[0,"ClrZone",1,0],[0,"LifterProcessCheck",1,0],[1,"ObjSelectTarget",0,"SelectNXObjectList",0],[1,"ObjSelectTool",0,"SelectNXObjectList",0],[0,"ObjSelectType",1,0],[0,"ScrewCheck",1,0],[0,"SelectDatasetsName",1,0],[0,"SelectStandardSetsSpreadsheet",1,0],[0,"SubAssembly",1,0]],[[[],"StdAddUserSets",{},0,0],[[],"StdLoadFile",{},0,0],[["dataSetName"],"RemoveDataSet",{},1,0]],[]];
SPLM.Tooling.ValidCheckBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ValidCheckBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ValidCheckBuilder.SelMode = Object.freeze({
    "Component" : "Component", "Body" : "Body"});

SPLM.Tooling.ValidCheckBuilder.AnalysisMode = Object.freeze({
    "SolidBased" : "SolidBased", "FacetBased" : "FacetBased"});

SPLM.Tooling.ValidCheckBuilder.CheckingType = Object.freeze({
    "TrueBody" : "TrueBody", "FalseBody" : "FalseBody", "Both" : "Both"});

export default SPLM;